import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
import FontStyles from '@polestar/component-warehouse-react/tokens/font-styles/FontStyles';
import FontWeights from '@polestar/component-warehouse-react/tokens/font-weights/FontWeights';
import Fonts from '@polestar/component-warehouse-react/tokens/fonts/Fonts';
const PolestarAppTheme = {
    polestarApp: {
        light: {
            backgroundColor: Colors.white,
            fontWeight: FontWeights.regular,
            fontFamily: Fonts.polestarUnica,
            fontFamilyRTL: Fonts.polestarUnicaRTL,
            fontStyle: FontStyles.normal,
            color: Colors.black,
            focus: {
                outer: {
                    width: '4px',
                    color: Colors.black,
                },
                inner: {
                    width: '2px',
                    color: Colors.white,
                },
            },
        },
        dark: {
            backgroundColor: Colors.black,
            color: Colors.white,
            focus: {
                outer: {
                    width: '4px',
                    color: Colors.white,
                },
                inner: {
                    width: '2px',
                    color: Colors.black,
                },
            },
        },
    },
};
export default PolestarAppTheme;
